import React, { useEffect, useState } from 'react';
import { Box, Container, Flex, Text } from '@spothero/ui';
import { Helmet } from 'react-helmet-async';
import { useRouteMatch, useHistory } from 'react-router';
import APIUtils from '@spothero/utils/api';
import ObjectUtils from '@spothero/utils/object';
import UrlUtils from '@spothero/utils/url';
const getReservation = async ({ reservationId, accessKey }) => {
    try {
        const response = await APIUtils.get(`/reservations/${reservationId}/?access_key=${accessKey}`);
        return ObjectUtils.camelizeKeys(response.data.data);
    }
    catch {
        return null;
    }
};
const ParkingPass = () => {
    const routeMatch = useRouteMatch();
    const history = useHistory();
    const urlParams = UrlUtils.parseParams(history.location.search);
    const accessKey = urlParams.key;
    const [reservation, setReservation] = useState(null);
    useEffect(() => {
        const getReservationData = async () => {
            const response = await getReservation({
                reservationId: routeMatch.params.id,
                accessKey,
            });
            if (response) {
                setReservation(response);
            }
        };
        getReservationData();
    }, [routeMatch, accessKey]);
    return (<Box as="main" paddingY={4} bgColor="gray.light">
            {/* @ts-expect-error */}
            <Helmet>
                <meta name="robots" content="noindex, nofollow"/>
                <body className="standalone-page"/>
            </Helmet>
            <Container>
                <Flex direction="column">
                    <Text>
                        This Page is deprecated and is only viewable locally and
                        on sandboxes. To see the parking pass page, replace
                        &quot;pass&quot; with &quot;parking-pass&quot; in the
                        URL.
                    </Text>

                    <Text marginTop={4}>
                        Facility: {reservation?.facility?.title}
                    </Text>
                    <Text marginTop={4}>
                        Reservation Id: {reservation?.displayId}
                    </Text>
                </Flex>
            </Container>
        </Box>);
};
export default ParkingPass;
